import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, TransitionGroup as _TransitionGroup, createTextVNode as _createTextVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-81345eac"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "w-full mt-10 bg-gray-400 backdrop-filter backdrop-blur-sm bg-opacity-10 p-5",
  id: "group"
}
const _hoisted_2 = { class: "" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between items-center pb-2 border-b-[1px] border-gray-800" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-sm text-left font-normal text-white" }, " RECOMMENDED READS "),
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center gap-3 items-center" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "w-3 h-3 rounded-full bg-yellow-300" }),
    /*#__PURE__*/_createElementVNode("span", { class: "w-3 h-3 rounded-full bg-red-800" }),
    /*#__PURE__*/_createElementVNode("span", { class: "w-3 h-3 rounded-full bg-orange-900" })
  ])
], -1))
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-[14px] w-[70%] pb-4 sx:w-full text-left mt-5 text-white" }, " Our book recommendation order is based on most reads from several book genre's. We are at the moment not in patnership with any brand to promote their products for more audience. Use the suggest button to recommend books you think people should read. ", -1))
const _hoisted_6 = { class: "grid-cols-sx-column m-[2%] sm:grid-cols-columns grid gap-[10px] md:gap-[30px]" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = {
  key: 1,
  class: "relative w-full image"
}
const _hoisted_9 = { style: {"padding":"14px"} }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","align-items":"center","justify-items":"space-between","margin-top":"16px","height":"16px"} }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fixed top-0 left-0 w-full h-screen overflow-hidden z-10 pointer-events-none" }, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "loader",
    class: "relative pl-0 pr-0 pt-0 bg-black w-0 h-full"
  })
], -1))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")

  return (_openBlock(), _createBlock(_Transition, {
    appear: "",
    onEnter: $options.enter
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_el_scrollbar, { height: "600px" }, {
              default: _withCtx(() => [
                _createVNode(_TransitionGroup, {
                  name: "list",
                  tag: "ul"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.bestSellers, (book) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: book,
                          class: "relative bg-[#2b2a34] rounded-[4px] overflow-hidden animate-mouseOut hover:animate-mouseOver"
                        }, [
                          (book.book_image)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: "",
                                class: "relative w-full before:content-['...'] before:text-24px before:absolute before:flex before:w-full before:h-full before:items-center before:justify-center before:z-0 before:text-[rgba(white, 0.1)] after:content-[''] after:pb-[5%] md:after:pb-[7%] after:block"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("img", {
                                    src: book.book_image,
                                    alt: book.title,
                                    class: _normalizeClass(["cursor-pointer top-0 left-0 h-[250px] md:h-[300px] w-full z-10 opacity-0 animate-imageFadeIn delay-[0.5s]", { active: $data.isActive }]),
                                    onLoad: _cache[0] || (_cache[0] = $event => ($options.isLoaded()))
                                  }, null, 42, _hoisted_7)
                                ]),
                                _: 2
                              }, 1024))
                            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createVNode(_component_el_skeleton, {
                                  style: {"width":"250px","height":"270px"},
                                  count: 8,
                                  loading: _ctx.loading,
                                  animated: ""
                                }, {
                                  template: _withCtx(() => [
                                    _createVNode(_component_el_skeleton_item, {
                                      variant: "image",
                                      style: {"width":"240px","height":"240px"}
                                    }),
                                    _createElementVNode("div", _hoisted_9, [
                                      _createVNode(_component_el_skeleton_item, {
                                        variant: "h3",
                                        style: {"width":"50%"}
                                      }),
                                      _hoisted_10
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["loading"])
                              ]))
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_11,
          _createVNode(_component_router_link, {
            to: "/book-recommendations",
            onPageTransition: $options.pageTransition,
            class: "mt-5 next-button transition-all relative before:content-[''] before:absolute before:top-0 before:left-0 rounded inline-flex text-sm bfore:w-full items-center px-6 py-2 sm:px-14 sm:py-3 text-white"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Click to view more ")
            ]),
            _: 1
          }, 8, ["onPageTransition"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onEnter"]))
}